/* ============================================================
   BT CTA + Conversion layer  (bt-cta.js)
   Additive script — loaded (defer) before </body> in theme.liquid.
   Every feature is null-guarded and wrapped so it can NEVER break
   the storefront. Safe to remove: delete the bt-cta.js <script> line.

   ---- Tunable settings ----
   BT_PRELAUNCH         : true = no product yet. Hides buying and shows
                          "coming soon" + Founding 50 reserve CTAs. Set to
                          false (and republish a theme without bt-cta.css
                          section 12) to reopen the store for real.
   F50_PRODUCT_PATH     : the ONE product that stays buyable during
                          pre-launch — the $100 Founding 50 First Batch
                          founder box (50 units, oversell OFF). Its page
                          gets body.bt-f50, which bt-cta.css section 12
                          uses to exempt it from buy-hiding.
   BT_FREE_SHIP_CENTS   : cart total (in cents) that unlocks the
                          free-shipping message. SET TO 0 TO DISABLE
                          the cart progress bar. NOTE: if you keep this
                          on, create a matching "free over $X" rate in
                          Settings > Shipping so it's real.
   ============================================================ */
(function () {
  'use strict';

  var BT_PRELAUNCH       = true;                 // no product to ship yet -> disable buying (except F50)
  var FOUNDING_URL       = '/pages/founding-50';
  var F50_PRODUCT_PATH   = '/products/founding-50-first-batch';
  var BT_FREE_SHIP_CENTS = 25000;                // $250 -> free shipping (set 0 to disable)
  var BT_FREE_SHIP_LABEL = 'free shipping';
  var SHOP_URL           = '/collections/shop-biltong';
  var SUBSCRIBE_URL      = '/pages/subscribe';

  var IS_F50 = window.location.pathname.indexOf(F50_PRODUCT_PATH) !== -1;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn, { once: true });
  }
  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  /* ---- 1. Announcement bar: scrolling promo marquee ---- */
  function initAnnouncement() {
    try {
      var el = document.querySelector('.announcement-bar__message');
      if (!el) return;
      var founding = '🔥 FOUNDING 50 · $100 FIRST-BATCH FOUNDER BOX · 50 SPOTS ONLY';
      var msgs = [
        founding,
        '⏳ REAL BILTONG, COMING SOON TO AUSTIN',
        '📦 $15 FLAT US SHIPPING · FREE OVER $250',
        '🌍 TWO CONTINENTS, ONE (UN)CUT'
      ];
      var sep = '<span class="bt-tick__sep" aria-hidden="true">✦</span>';
      var run = msgs.join(sep) + sep;

      // reduced-motion: rotate messages in place instead of scrolling
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce) {
        var i = 0;
        el.textContent = msgs[0];
        if (msgs.length > 1) {
          setInterval(function () {
            i = (i + 1) % msgs.length;
            el.textContent = msgs[i];
          }, 4200);
        }
        return;
      }

      // seamless horizontal scroll: two identical runs, animate track -50%
      el.innerHTML =
        '<span class="bt-tick">' +
          '<span class="bt-tick__run">' + run + '</span>' +
          '<span class="bt-tick__run" aria-hidden="true">' + run + '</span>' +
        '</span>';
    } catch (e) {}
  }

  /* ---- 2. Header CTA button ---- */
  function initHeaderCTA() {
    try {
      var icons = document.querySelector('.header__icons');
      if (!icons || document.querySelector('.bt-shop-btn')) return;
      var a = document.createElement('a');
      a.href = BT_PRELAUNCH ? FOUNDING_URL : SHOP_URL;
      a.className = 'button button--primary bt-shop-btn';
      a.textContent = BT_PRELAUNCH ? 'Claim Your Spot' : 'Order Now';
      icons.insertBefore(a, icons.firstChild);
    } catch (e) {}
  }

  /* ---- 2b. Hero primary CTA pulse (first section only) ---- */
  function initHeroPulse() {
    try {
      var firstSection = document.querySelector('#MainContent .shopify-section');
      if (!firstSection) return;
      var btn = firstSection.querySelector('.button');
      if (btn) btn.classList.add('bt-pulse');
    } catch (e) {}
  }

  /* ---- 2c. PRE-LAUNCH "coming soon" (product pages + cards) ---- */
  function initComingSoon() {
    if (!BT_PRELAUNCH || IS_F50) return;
    try {
      var anchor = document.querySelector('.product-form')
                || document.querySelector('.product-form__buttons');
      if (anchor && !document.querySelector('.bt-soon')) {
        var panel = document.createElement('div');
        panel.className = 'bt-soon';
        panel.innerHTML =
          '<p class="bt-soon__kicker">Coming Soon</p>' +
          '<p class="bt-soon__title">Not on the shelf yet.</p>' +
          '<p class="bt-soon__sub">We’re firing up the first batch — and only the Founding 50 eat from it. $100 gets you a first-batch founder box, a numbered spot, merch and early access.</p>' +
          '<a class="button button--primary" href="' + F50_PRODUCT_PATH + '">Claim a Founding 50 box →</a>' +
          '<a class="button button--secondary" href="' + FOUNDING_URL + '">The full founder deal</a>';
        anchor.insertAdjacentElement('afterend', panel);
      }
      var headings = document.querySelectorAll('.card__information .card__heading');
      Array.prototype.forEach.call(headings, function (h) {
        if (h.parentNode.querySelector('.bt-soon-tag')) return;
        var tag = document.createElement('span');
        tag.className = 'bt-soon-tag';
        tag.textContent = 'Coming soon';
        h.insertAdjacentElement('afterend', tag);
      });
    } catch (e) {}
  }

  /* ---- 3. Sticky mobile Add-to-Cart bar (product pages) ---- */
  function initBuyBar() {
    try {
      if (BT_PRELAUNCH && !IS_F50) return;
      var main = document.querySelector('main[data-template]');
      var isProduct = (main && (main.dataset.template || '').indexOf('product') === 0) || IS_F50;
      if (!isProduct) return;

      var realBtn = document.querySelector('product-form .product-form__submit')
                 || document.querySelector('.product-form__submit');
      var titleEl = document.querySelector('.product__title h1, .product__title, h1.product__title');
      if (!realBtn || !titleEl) return;

      var bar = document.createElement('div');
      bar.className = 'bt-buybar';
      bar.innerHTML =
        '<div class="bt-buybar__info">' +
          '<span class="bt-buybar__title"></span>' +
          '<span class="bt-buybar__price"></span>' +
        '</div>' +
        '<button type="button" class="button button--primary bt-buybar__btn">ADD</button>';
      document.body.appendChild(bar);

      bar.querySelector('.bt-buybar__title').textContent = (titleEl.textContent || '').trim();
      function syncPrice() {
        var p = document.querySelector('.price__container .price-item--sale, .price__container .price-item--regular, .price-item--regular');
        if (p) bar.querySelector('.bt-buybar__price').textContent = (p.textContent || '').trim();
      }
      syncPrice();

      var pc = document.querySelector('.price, .price__container');
      if (pc && 'MutationObserver' in window) {
        new MutationObserver(syncPrice).observe(pc, { subtree: true, childList: true, characterData: true });
      }

      bar.querySelector('.bt-buybar__btn').addEventListener('click', function () {
        if (realBtn.getAttribute('disabled') !== null) return;
        realBtn.click();
      });
      function syncState() {
        var disabled = realBtn.getAttribute('disabled') !== null;
        var b = bar.querySelector('.bt-buybar__btn');
        b.disabled = disabled;
        b.textContent = disabled ? 'SOLD OUT' : 'ADD';
      }
      syncState();
      if ('MutationObserver' in window) {
        new MutationObserver(syncState).observe(realBtn, { attributes: true, attributeFilter: ['disabled'] });
      }

      requestAnimationFrame(function () { bar.classList.add('is-visible'); });
    } catch (e) {}
  }

  /* ---- 4. Cart free-shipping progress + subscribe nudge ---- */
  function renderShipBar(container, cart) {
    if (!container) return;
    var bar = container.querySelector('.bt-shipbar');
    var nudge = container.querySelector('.bt-sub-nudge');
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'bt-shipbar';
      bar.innerHTML = '<p class="bt-shipbar__msg"></p><div class="bt-shipbar__track"><div class="bt-shipbar__fill"></div></div>';
      container.insertBefore(bar, container.firstChild);
    }
    if (!nudge) {
      nudge = document.createElement('a');
      nudge.className = 'bt-sub-nudge';
      nudge.href = SUBSCRIBE_URL;
      nudge.textContent = 'Make it monthly & save 10% →';
      bar.insertAdjacentElement('afterend', nudge);
    }
    var total = cart.total_price || 0;
    var remaining = BT_FREE_SHIP_CENTS - total;
    var pct = Math.max(0, Math.min(100, (total / BT_FREE_SHIP_CENTS) * 100));
    bar.querySelector('.bt-shipbar__fill').style.width = pct + '%';
    if (remaining <= 0) {
      bar.classList.add('is-complete');
      bar.querySelector('.bt-shipbar__msg').innerHTML = '🎉 You’ve unlocked <strong>' + BT_FREE_SHIP_LABEL + '</strong>!';
    } else {
      bar.classList.remove('is-complete');
      bar.querySelector('.bt-shipbar__msg').innerHTML = 'You’re <strong>' + money(remaining) + '</strong> from <strong>' + BT_FREE_SHIP_LABEL + '</strong>';
    }
  }

  function updateCartUI() {
    if (BT_PRELAUNCH || !BT_FREE_SHIP_CENTS) return;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.item_count) return;
        renderShipBar(document.querySelector('.cart-drawer__inner .drawer__cart, .cart-drawer__inner form, .cart-drawer .drawer__inner'), cart);
        renderShipBar(document.querySelector('.cart__items, cart-items, #main-cart-items'), cart);
      })
      .catch(function () {});
  }

  function initCartWatch() {
    if (BT_PRELAUNCH || !BT_FREE_SHIP_CENTS) return;
    updateCartUI();
    try {
      var origFetch = window.fetch;
      window.fetch = function () {
        var args = arguments;
        var url = (args[0] && args[0].url) || args[0] || '';
        var p = origFetch.apply(this, args);
        if (typeof url === 'string' && /\/cart\/(add|change|update)/.test(url)) {
          p.then(function () { setTimeout(updateCartUI, 250); }).catch(function () {});
        }
        return p;
      };
    } catch (e) {}
    document.addEventListener('click', function (ev) {
      var t = ev.target;
      if (t && t.closest && t.closest('#cart-icon-bubble, .cart-drawer, [href$="/cart"]')) {
        setTimeout(updateCartUI, 300);
      }
    }, true);
  }

  ready(function () {
    if (IS_F50) { try { document.body.classList.add('bt-f50'); } catch (e) {} }
    initAnnouncement();
    initHeaderCTA();
    initHeroPulse();
    initComingSoon();
    initBuyBar();
    initCartWatch();
  });
})();
